import { useCallback, useState } from 'react';

export interface UseControlledProps<Value> {
  defaultValue: Value;
  value?: Value;
}

export function useControlled<Value>({
  defaultValue: default_value_props,
  value: value_props,
}: UseControlledProps<Value>): [Value, (newValue: Value) => void] {
  const [value_state, setValueState] = useState<Value>(default_value_props);
  const is_controlled = value_props !== undefined;
  const value = is_controlled ? value_props : value_state;

  const setValue = useCallback(
    (newValue: Value) => {
      if (is_controlled) {
        return;
      }
      setValueState(newValue);
    },
    [is_controlled],
  );

  return [value, setValue];
}
